import { NodeInputProps } from "./helpers";
export function NodeInputHidden({
  attributes
}: NodeInputProps) {
  // Render a hidden input field
  return <input type={attributes.type} name={attributes.name} value={attributes.value || "true"} data-sentry-component="NodeInputHidden" data-sentry-source-file="NodeInputHidden.tsx" />;
}